import { useEffect, useState } from 'react';

export default function usePageAira({ noFocus, ref: outsideRef } = {}) {
  const [refState, setRefState] = useState(null);

  const setRef = (ref) => {
    setRefState(ref);
    if (typeof outsideRef === 'function') {
      outsideRef(ref);
    } else if (typeof outsideRef === 'object') {
      // eslint-disable-next-line no-param-reassign
      outsideRef.current = ref;
    }
  };

  useEffect(() => {
    if (!refState || noFocus) return;

    refState.focus();
  }, [refState]);

  return {
    ref: setRef,
    tabIndex: '-1',
    style: {
      outline: 'none',
    },
  };
}
